package games.polyclub.website.frontend.store.pages

import games.polyclub.frontend.lib.react.bootstrap.components.Card
import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.message.unaryMinus
import games.polyclub.website.frontend.store.layout.PageBody
import games.polyclub.website.frontend.store.layout.PageHeader
import react.Props

val UnauthorizedPage = SFC<Props> { _->
    PageHeader {
        title = -"Permissão NEGADA!"
    }
    PageBody {
        Card {
            title = "Eeeita!!!"
            +"O que você estava tentando fazer, eeeiim?? 👀👀👀"
        }
    }
}
